<nz-divider
    class="no-margin"
    nzPlain="true"
    [nzText]="text"
    nzOrientation="left"
>
    <ng-template #text>
        <div class="sider-divider-text">
            {{ datasourceColumnLabel }}
        </div>
    </ng-template>
</nz-divider>
<input
    nz-input
    [placeholder]="datasourceColumnLabel"
    [(ngModel)]="value"
    (ngModelChange)="onModelChange($event)"
    type="string"
    nzSize="small"
/>
